import { upperFirst } from 'lodash'

import { regExp } from '@sigma-frontend-libs/commons'

import { labelModes, proxy } from '@/utils'

import settingsFields from '@/components/services/settings/fields'

export default function(options) {
  const currency = options?.payload?.settings?.['billings.currency']

  return {
    name: options.path.split('.').map(upperFirst).join(''),

    mixins: [ proxy({ type: 'object' }) ],

    methods: {
      watchValueHandler() {
        return
      },
      watchProxyHandler() {
        return
      }
    },

    render(h) {
      return h(
        settingsFields(options, { type: 'object' }),
        {
          props: {
            value: this.proxy,
            cols: 2,
            items: [ 'limit', 'requiredBalance' ].map(field => {
              return {
                field,
                props: {
                  label: null,
                  hint: this.getTranslate(`${options.serviceName}.hints.${options.path}.${field}`),
                  suffix: this.getTranslate(`currency.${currency}.symbol.unicode`),
                  labelMode: labelModes.hidden,
                  mask: regExp.positiveNumberTwoSymbolsAfterDot,
                  details: true
                }
              }
            })
          },
          on: {
            input: event => {
              this.$emit('input', event)
            }
          }
        }
      )
    }
  }
}
